import { Component, Input, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { PermissionsEnum } from 'src/app/enums/permissions.enum';
import { PepService } from 'src/app/services/http/pep/pep.service';
import { PermissionService } from 'src/app/services/http/permission/permission.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';
import { PepControllerService } from '../../controller/pep-controller.service';

@Component({
  selector: 'delete-datafield',
  templateUrl: './delete-datafield.component.html',
  styleUrls: ['./delete-datafield.component.scss']
})
export class DeleteDatafieldComponent {

  @Input() datafieldId: string = null
  @Output() datafieldDeleted: Subject<void> = new Subject<void>()
  verifyUserPermission$: Observable<boolean> = this.permissionService.verify(PermissionsEnum.EDIT_DATASHEET)

  constructor(
    private pepService: PepService,
    private permissionService: PermissionService,
    private pageController: PepControllerService,
    private snackbarService: SnackbarService
  ) { }

  deleteDatafield(): void {
    this.pepService.deleteDatafield(this.datafieldId)
      .pipe(take(1))
      .subscribe(() => {
        this.pageController.refresh()
        this.datafieldDeleted.next()
        this.snackbarService.show('Campo da ficha de prontuário excluído.')
      }, error => {
        this.snackbarService.showError('Campo não foi excluído, por favor tente novamente.')
      })
  }
}
